export type CsvCell = string | number | null | undefined

/**
 * Serializes rows to CSV and triggers a browser download.
 * Cells are quoted and escaped; a UTF-8 BOM is prepended so Excel
 * renders diacritics correctly.
 */
export const downloadCsv = (rows: CsvCell[][], filename: string): void => {
  const csv = rows
    .map(row =>
      row.map(cell => `"${String(cell ?? '').replace(/"/g, '""')}"`).join(','),
    )
    .join('\n')

  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const linkElement = document.createElement('a')
  linkElement.href = url
  linkElement.download = filename
  linkElement.click()
  URL.revokeObjectURL(url)
}
